import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  DeactivationConfirmForm,
  DeactivationConfirmFormProps,
} from './DeactivationConfirmForm'

export * from './fragments'

export type State = {}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: DeactivationConfirmFormProps['onSubmit']
}

export const DeactivationConfirmTemplate: Template<State, Action> = ({
  onSubmit,
}) => {
  const { routerNames, routerPages } = useRouter()
  const { t } = useTranslation('deactivationConfirm')
  return (
    <>
      <Head title={routerNames.DeactivationConfirm} />
      <BaseLayout
        header={{
          back: true,
          defaultBackPage: routerPages.Deactivation,
          title: t('title'),
        }}
      >
        <DeactivationConfirmForm onSubmit={onSubmit} />
      </BaseLayout>
    </>
  )
}
